module.exports = __webpack_public_path__ + "assets/media/tongue_practice.450e0a7b.mp4";